"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Nipple: () => Nipple,
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);

// src/Nipple.tsx
var import_react = require("react");
var import_nipplejs = __toESM(require("nipplejs"));
var import_jsx_runtime = require("react/jsx-runtime");
var Nipple = (props) => {
  const innerRef = (0, import_react.createRef)();
  const {
    options = {},
    onStart = () => {
    },
    onEnd = () => {
    },
    onMove = () => {
    },
    onDir = () => {
    },
    onPlain = () => {
    },
    onShown = () => {
    },
    onHidden = () => {
    },
    onPressure = () => {
    },
    ...divProps
  } = props;
  (0, import_react.useEffect)(() => {
    var _a, _b;
    const options2 = {
      ...props.options,
      ...(innerRef == null ? void 0 : innerRef.current) && { zone: ((_a = props == null ? void 0 : props.options) == null ? void 0 : _a.zone) || (innerRef == null ? void 0 : innerRef.current) },
      ...((_b = props == null ? void 0 : props.options) == null ? void 0 : _b.mode) === "static" && {
        position: {
          top: "50%",
          left: "50%"
        }
      }
    };
    let _manager = import_nipplejs.default.create(options2);
    const handleNippleStart = (e, data) => (props == null ? void 0 : props.onStart) && props.onStart(e, data);
    const handleNippleEnd = (e, data) => (props == null ? void 0 : props.onEnd) && props.onEnd(e, data);
    const handleNippleMove = (e, data) => (props == null ? void 0 : props.onMove) && props.onMove(e, data);
    const handleNippleDir = (e, data) => (props == null ? void 0 : props.onDir) && props.onDir(e, data);
    const handleNipplePlain = (e, data) => (props == null ? void 0 : props.onPlain) && props.onPlain(e, data);
    const handleNippleShown = (e, data) => (props == null ? void 0 : props.onShown) && props.onShown(e, data);
    const handleNippleHidden = (e, data) => (props == null ? void 0 : props.onHidden) && props.onHidden(e, data);
    const handleNipplePressure = (e, data) => (props == null ? void 0 : props.onPressure) && props.onPressure(e, data);
    _manager.on("start", handleNippleStart);
    _manager.on("end", handleNippleEnd);
    _manager.on("move", handleNippleMove);
    _manager.on("dir", handleNippleDir);
    _manager.on("plain", handleNipplePlain);
    _manager.on("shown", handleNippleShown);
    _manager.on("hidden", handleNippleHidden);
    _manager.on("pressure", handleNipplePressure);
    return () => {
      _manager.off("start", handleNippleStart);
      _manager.off("end", handleNippleEnd);
      _manager.off("move", handleNippleMove);
      _manager.off("dir", handleNippleDir);
      _manager.off("plain", handleNipplePlain);
      _manager.off("shown", handleNippleShown);
      _manager.off("hidden", handleNippleHidden);
      _manager.off("pressure", handleNipplePressure);
      _manager.destroy();
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
    ref: innerRef,
    ...divProps,
    style: {
      position: "relative",
      width: "100px",
      height: "100px",
      overflow: "hidden",
      margin: "auto",
      ...props == null ? void 0 : props.style
    }
  });
};

// src/index.tsx
var import_nipplejs2 = require("nipplejs");
var src_default = Nipple;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Nipple
});
